@if (showMatrix && !matrixLoader) {
<div class="container-fluid inbuilt-table-block p-1">
  <div class="row">
    <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center">
      <p class="m-0 mt-2 report-fetch-details">
        {{ config?.reportNameFromQueryParams | titlecase }} : {{ matrixGeneratedRowCount || 0 }} rows as of
        {{ currentDate | date: 'MMM dd,yyyy':'GMT' }} {{ currentTime }}
      </p>
    </div>
    <div class="col-12 col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 text-right">
      <div class="m-2">
        <button
          class="ms-2 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base"
          (click)="toggleExpandCollapseAll()"
          [disabled]="matrixRowData.length === 0"
        >
          {{ allExpanded ? 'Collapse All' : 'Expand All' }}
        </button>
        <span
          (click)="!isDownloadDisabled && downloadAndExportToExcel()"
          title="Click to Download"
          [class.cursor-not-allowed]="isDownloadDisabled"
          [class.opacity-50]="isDownloadDisabled"
          [ngClass]="{ 'pointer-events-none': isDownloadDisabled }"
          class="uitk-icon uitk-icon-download md-icon excel_Download cursor-pointer excelandinfo-Icon-font"
        ></span>
        @if (isExporting) {
        <div class="export-loader ms-2" style="display: inline-block;">
          <mat-spinner class="spinner" diameter="24"></mat-spinner>
        </div>
        }
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div #matrixContainer class="col-12 ag-table-container position-relative">
      @if (!loading && matrixRowData.length === 0) {
      <div class="matrix-empty">
        No drill-down matrix data available.
      </div>
      } @if (!loading && matrixRowData.length > 0) {
      <ag-grid-angular
        class="ag-theme-alpine matrix-grid"
        [rowData]="matrixRowData"
        [columnDefs]="matrixColumnDefs"
        [defaultColDef]="defaultColDef"
        [animateRows]="true"
        [suppressMultiSort]="true"
        [suppressColumnVirtualisation]="true"
        [getRowId]="getRowId"
        [postSortRows]="postSortRows"
        (gridReady)="onGridReady($event)"
        (sortChanged)="onSortChanged()"
        (cellClicked)="onCellClicked($event)"
      >
      </ag-grid-angular>
      } @if (loading) {
      <div class="matrix-loading-overlay">
        <mat-spinner diameter="50" strokeWidth="4"></mat-spinner>
      </div>
      }
    </div>
  </div>
</div>
} @if (showMatrix && matrixLoader) {
<div class="d-flex align-items-center justify-content-center">
  <app-loader></app-loader>
</div>
}
